import bindAllOfThis, { bindAllOfThisTheHardWay } from "src/utils/BindThisHelper";
import { MainScene } from "./MainScene";
import TranslateApi from "src/utils/TranslateHelper";

export class ChooseVehicleScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;

    constructor() {
        super({
            key: "ChooseVehicleScene"
        });
        bindAllOfThis(this, ChooseVehicleScene.prototype);
    }

    preload() {
        this.load.image("background", require("src/assets/qci/backgrounds/kr_background.png"));
        this.load.atlas("assets", require("src/assets/qci/atlas/gameConstructionMaze.png"), require("src/assets/qci/atlas/gameConstructionMaze.json"));
    }

    create() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        var background = this.add.image(0, 0, "background").setOrigin(0);
        var modal = this.add.image(0, 0, "assets", "Modal").setOrigin(0);

        var x = 400;
        var y = 550;

        var style = { fontSize: 20, fontFamily: "Russo One, Arial", color: "#000000"};

        var title = this.add.text(150, 400, TranslateApi.translate("ConstructionMaze.Phaser.modalTitle"), style);
        title.setFontSize(30);

        for(var i = 1; i < 4; i++) {
            var vehicle = this.createVehicle(x, y, i);
         
            var label = this.add.text(x, y, i + ':' + TranslateApi.translate("ConstructionMaze.Phaser.vehicle" + i), style);
            Phaser.Display.Align.In.TopCenter(label, vehicle);
    
            label.y += 250;
            x+= 300;
        }

        this.bindKeyboard();
    }

    selectVehicle(id: number) {
        MainScene.VehicleFrame = "vehicle" + id + "little";
        this.input.enabled = false;
        this.scene.add("MainScene", MainScene, true);
        this.scene.remove("ChooseVehicleScene");
    }

    createVehicle(x, y, id: number) {
        var vehicle = this.add.image(x, y, "assets", "vehicle" + id + "big");
        vehicle.setInteractive({useHandCursor: true});
        vehicle.on('pointerdown', () => {
            this.selectVehicle(id);
        });

        return vehicle;
    }

    onKeydown(event: Function, ...keys: string[]): void {
        keys.forEach((key: string) => {
            this.input.keyboard.on('keydown_' + key, event);
        });
    }

    bindKeyboard(): void {
        this.onKeydown(() => { this.selectVehicle(1); }, 'ONE', 'NUMPAD_ONE');
        this.onKeydown(() => { this.selectVehicle(2); }, 'TWO', 'NUMPAD_TWO');
        this.onKeydown(() => { this.selectVehicle(3); }, 'THREE', 'NUMPAD_THREE');
    }
}



// WEBPACK FOOTER //
// ./src/games/ConstructionMazeGame/scenes/ChooseVehicleScene.ts